document.addEventListener('alpine:init', () => {
  Alpine.data('logo', () => ({   
    init() {
      this.$nextTick(() => {
        const modelViewer = this.$refs.modelViewer;
        const poster = this.$refs.poster;

        if (modelViewer && poster) {
          modelViewer.addEventListener('load', () => {
            poster.remove();
          });
        }
      });
    },
  }))
});